"use client";

import React, { useContext, useEffect } from "react";

import { ModalsContext } from "@/context/ModalsContext";

import "./RichTextForBlog.css";

interface RichTextProps {
  content: {
    html: string;
  };
  leadFormPageLocation?: string;
}

export default function RichTextForBlog({ content, leadFormPageLocation }: RichTextProps) {
  const { setEnquireModalOpen, setGetFormPageLocation } = useContext(ModalsContext);
  useEffect(() => {
    if (typeof window === "undefined") return;
    // Remove extra tags inside <a href="#enquire">
    document?.querySelectorAll('a[href="#enquire"]').forEach((anchor) => {
      anchor.innerHTML = anchor.textContent || ""; // Keep only text content
    });

    // Add event listeners to intercept clicks on anchor tags with href="#enquire"
    const handleEnquireClick = (event: MouseEvent) => {
      let target = event.target as HTMLElement;

      // Ensure we get the <a> tag even if clicking inside a child tag
      while (target && target.tagName !== "A") {
        target = target.parentElement as HTMLElement;
      }

      if (target?.tagName === "A" && target.getAttribute("href") === "#enquire") {
        event.preventDefault(); // Prevent default anchor behavior
        // const contactForm = document?.getElementById("contactForm");
        // if (contactForm) {
        // contactForm.scrollIntoView({ behavior: "smooth" }); // Smooth scroll to ContactForm
        setEnquireModalOpen(true);
        setGetFormPageLocation(leadFormPageLocation);
        // }
      }
    };

    // Attach the event listener to the document
    document.addEventListener("click", handleEnquireClick);

    // Cleanup the event listener on unmount
    return () => {
      document.removeEventListener("click", handleEnquireClick);
    };
  }, [setEnquireModalOpen]);

  return <div className="rich-text-blog" dangerouslySetInnerHTML={{ __html: content.html }} />;
}
